import * as React from 'react';
import './styles.scss';
import { forwardRef } from 'react';
import { ErrorMessage } from 'react-hook-form';

export interface FormRadioProps extends React.HTMLAttributes<HTMLInputElement> {
  label: JSX.Element;
  opts?: {
    [id: string]: { label: JSX.Element; value: any; };
  }
  name: string;
  errors?: any;
  showReadOnly?: boolean;
  selectedValue?: any;
}


export const FormRadio = forwardRef<HTMLInputElement, FormRadioProps>(
  ({ label, opts, name, errors, showReadOnly, selectedValue, ...inputProps }, ref) => {
    const hasError: boolean = errors && errors[name];
    const radios = opts && Object.keys(opts).map((key: string) => {
      return (!showReadOnly || (showReadOnly && selectedValue === opts[key].value)) &&
        <div className="radio-wrapper" key={key}>
          <input {...inputProps}
            id={key}
            name={name}
            type="radio"
            className={`input--radio ${hasError ? "input--error" : ""}`}
            value={opts[key].value}
            ref={ref}
            defaultChecked={selectedValue === opts[key].value}
            tabIndex={showReadOnly ? -1 : 0} />
          <label className="label--radio" htmlFor={key} key={key}>{opts[key].label}</label>
        </div>
    });

    return (
      <>
        <fieldset className="form-radios__fieldset">
          <legend className={`${showReadOnly ? "form-radio__read-only" : ""}`}>{label}</legend>
          <div className="form-radios__radios">
            {radios}
          </div>
        </fieldset>
        {hasError && <div className="form-input__error"><ErrorMessage errors={errors} name={name} /></div>}
      </>
    )
  }
);

